module.exports = __webpack_public_path__ + "img/whatsapp_blackandwhite.20d6441.png";